import { makeStyles } from '@fluentui/react-components';

export const useFooterStyles = makeStyles({
  container: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  saveButton: {
    marginRight: '8px',
  },
  containerLeft: {
    marginTop: '8px',
    display: 'flex',
  },
});
